import React from 'react';
import ReactDOM from 'react-dom';
import App from './App'; // This is your main component

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')  // This points to the `root` div in `public/index.html`
);
